<template>
  <div class="c-select-targeting">
    <div class="c-wrap">
      <div class="c-bar">
        <div ref="barContent" class="c-bar-content">
          <template v-for="(target, i) in data">
            <div :key="i" @click="setCurrent(i)" :class="classes(target)">
              <span>{{ text }}{{ i + 1 }}</span>
              <span class="m-remove" @click.stop="delCurrent(i)">x</span>
            </div>
          </template>
        </div>
        <div class="c-bar-btn">
          <!-- 投放方式不是全自动投放时显示，全自动投放不能添加多个定向 -->
          <Button v-if="deliveryType !== 3" :disabled="!adder" @click="addTarget">添加{{ text }}</Button>
          <Button type="primary" :disabled="!adder" @click="selectTarget">选择定向</Button>
        </div>
      </div>
    </div>
    <targeter
      v-model="targetModal"
      :data="targetList"
      :total="targetTotal"
      :open-id="defaultOpenId"
      :loading="loading"
      :multiple="isMultiple"
      :platform="defaultPlatform"
      @on-cancel="targetModal = false"
      @on-search="searchTarget"
      @on-change="filterTarget"
      @on-select="saveTarget"
      @on-platform="changePlatform"
    ></targeter>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray, timeout } from '@/common/js/utils'
import { deCompile, teCompile } from '@/common/js/decompile'
import { ksCompile } from '@/common/js/kscompile'
import { bdCompile } from '@/common/js/bdcompile'
import { getTargetingData } from '@/api/manage.model'

import Targeter from '@/components/target/manager.vue'

export default {
  name: 'selectTargeter',
  components: { Targeter },
  props: {
    value: {
      type: Boolean
    },
    data: {
      type: Array
    },
    media: {
      type: [Number, String]
    },
    disabled: {
      type: Boolean,
      dafault() {
        return false
      }
    },
    adder: {
      type: Boolean,
      default() {
        return true
      }
    },
    deliveryType: {
      type: Number
    },
    openId: {
      type: [Number, String]
    },
    orignData: {
      type: Object,
      default() {
        return {}
      }
    },
    platform: {
      type: [Number, String]
    },
    text: {
      type: String,
      default() {
        return '定向'
      }
    }
  },
  computed: {
    classes() {
      return (item) => {
        return ['m-creative-btn', { 'm-current': item.check }]
      }
    },
    // 投放方式是全自动投放时，只能选一个定向包
    isMultiple() {
      return this.deliveryType !== 3
    }
  },
  methods: {
    getData(filter) {
      let params = { mediaId: this.media, pageIndex: 1, pageSize: 10 }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))

      this.loading = true
      getTargetingData(params).then((data) => {
        if (typeof data !== 'symbol') this.loading = false
        if (!data) return
        const { list, page_info } = data

        if (isArray(list) && page_info) {
          const { total_number } = page_info
          this.targetTotal = total_number || 0
          this.targetList = list.map((ret) => {
            if (this.media === 16) ret.targets = teCompile(ret.targetingParamJson, this.orignData)
            else if (this.media === 32) ret.targets = ksCompile(ret.targetingParamJson, this.orignData)
            else if (ret.mediaId === 45) ret.targets = bdCompile(ret.targetingParamJson, this.orignData)
            else ret.targets = deCompile(ret.targetingParamJson, this.orignData)
            return ret
          })
        }
      })
    },
    setOperatorStorage(name, value) {
      const account = this.openId || Cookies.get('ch_op_id')
      const storage = getLocal(name) || {}
      if (account) {
        storage[account] = value
        setLocal(name, storage)
      }
    },
    setOpenId() {
      const account = this.openId || ''
      const storage = getLocal('select-target')
      this.defaultOpenId = storage && storage[account] ? storage[account] : account
      this.defaultPlatform = this.platform || ''
    },
    filterTarget(params) {
      this.getData(params)
    },
    searchTarget(params) {
      this.getData(params)
    },
    selectTarget() {
      this.targetModal = true
      this.setOpenId()
      if (this.params) {
        this.params.pageIndex && (this.params.pageIndex = 1)
        this.params.keyword && delete this.params.keyword
      }
      this.getData(this.params || {})
    },
    saveTarget(meta) {
      console.log('metametameta output: ', meta)
      this.$emit('input', false)
      timeout(0).then(() => {
        this.$emit('on-select', meta)
        // 记录上次成功opId
        this.setOperatorStorage('select-target', this.params.createOpId || -1)
        this.targetModal = false
      })
    },
    setCurrent(id) {
      this.$emit('on-current', id)
    },
    delCurrent(id) {
      this.$emit('on-delete', id)
    },
    changePlatform(id) {
      this.defaultPlatform = id
    },
    addTarget() {
      this.$emit('on-select')
    }
  },
  data() {
    return {
      loading: null,
      targetModal: null,
      targetList: [],
      targetTotal: 0,
      defaultOpenId: '',
      defaultPlatform: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.ivu-affix .c-select-targeting {
  border-bottom: 1px solid #e8eaec;
}

.c-select-targeting {
  // position: absolute;
  width: 100%;
  background-color: #fff;
  padding: 8px 24px 15px 48px;

  .c-wrap {
    display: flex;

    .c-bar {
      position: relative;
      display: flex;
      white-space: nowrap;
      justify-content: space-between;
      height: 52px;
      width: 100%;

      .c-bar-content {
        overflow-x: auto;
        scrollbar-width: thin;
        -webkit-overflow-scrolling: touch;

        height: 52px;
        display: inline-block;
        flex: auto;
        padding-top: 6px;

        .m-creative-btn {
          border-radius: 4px;
          border: solid 1px #efefef;

          position: relative;
          display: inline-block;
          line-height: 32px;
          padding: 0 12px;
          margin-right: 12px;
          cursor: default;

          .m-creat-btn {
            color: #2b85e4;
          }

          .m-remove {
            position: absolute;
            cursor: pointer;
            color: #fff;
            width: 11px;
            height: 11px;
            line-height: 11px;
            font-size: 60%;
            border-radius: 9px;
            background-color: #ff635c;
            text-align: center;
            display: block;
            z-index: 11;
            top: -6px;
            right: -3px;
            transition: display 0.2s ease-in-out;
          }
        }

        .m-current {
          color: #ffffff;
          border-color: #2b85e4;
          background-color: #2b85e4;
        }
      }

      .c-bar-btn {
        flex: 0 0 176px;
        margin-top: 6px;
        text-align: right;

        .ivu-btn {
          margin-left: 8px !important;
        }
      }
    }
  }
}
</style>
